<div class="m-t-20">
  <div class="heading-tab">
    <h3 class="heading"><i nz-icon nzType="file-text"></i> {{'Bank Details' | MMSTranslate}}</h3>
  </div>  <h3 id="payerId" class="heading" style="margin-bottom: 0px">Bank Details of {{this.bankBeneficiaryRole}}</h3>
  <nz-tabset [nzSize]="'large'">
    <ng-container *ngFor="let data of payeeList; let payeeIndex=index; ">
      <ng-template #titleTmplBankNominee>
        <strong class="d-b">Payer {{payeeIndex+1}}: {{data?.clientDO[0]?.firstName}}
          {{data?.clientDO[0]?.lastName}}</strong>
        <p class="col-green m-b-5">
          Bank details added
          <!-- <button nz-button nzType="primary" class="w-100-pc b-r-0" (click)="askAllChildrenForData()"><i nz-icon nzType="safety"
                nzTheme="outline"></i> Ask data</button> -->
        </p>
      </ng-template>
      <nz-tab [nzTitle]="titleTmplBankNominee">
        <div class="text-a-right">
          <button nz-button nzType="primary" (click)="addNewBankForm()">Add Bank</button>
        </div>
        <div class="card-container">
          <nz-tabset nzType="card" [nzSelectedIndex]="enableSpecificBankTab">
            <nz-tab *ngFor="let bankData of bankDataList; let indx = index;" [nzTitle]="'Bank '+ (indx+1)">

              <div class="m-b-20" style="width:400px;">
                <nz-form-item>
                  <nz-form-label [nzSpan]="24">Purpose</nz-form-label>
                  <nz-form-control [nzSpan]="24">
                    <nz-select nzShowSearch nzAllowClear nzMode="multiple" nzPlaceHolder="Select Purpose" [(ngModel)]="bankDataList[indx]['bankFormPurpose']" (ngModelChange)="updateBankPurpose($event,indx)">
                      <nz-option *ngFor="let item of (lookup$.AccountPurpose | async) as purposeCd; trackBy:item?.lookupKey"
                        [nzLabel]="item?.lookupValue" [nzValue]="item?.lookupKey"></nz-option>
                      <!-- <nz-option nzLabel="Auto Debt" nzValue="autoDebt"></nz-option>
                      <nz-option nzLabel="Refund Premium" nzValue="refundPremium"></nz-option>
                      <nz-option nzLabel="Claim Payment" nzValue="claimPayment"></nz-option> -->
                      <!-- <nz-option *ngFor="let item of (lookup$.purposeCd | async) as purposeCd; trackBy:item?.lookupKey"
                        [nzLabel]="item?.lookupValue" [nzValue]="item?.lookupKey">
                    </nz-option> -->
                    </nz-select>
                  </nz-form-control>
                </nz-form-item >
              </div>

              <bank-details [inputDataForEdit]="data" [smartUIConfig]="smartUIConfig"
                (componentOutput)="_BaseEmitHandler($event, data['clientDO']? data['clientDO'][0]['clientNum'] : null)" [entityGuid]="guid">
              </bank-details>
            </nz-tab>
          </nz-tabset>
        </div>

      </nz-tab>
    </ng-container>
  </nz-tabset>
  <app-generic-zero-ui [list]="payeeList" icon="file-search" [title]="multiCaptureBankDetails['title']"
    [message]="multiCaptureBankDetails['message']"></app-generic-zero-ui>
</div>